<template>
  <div>
    <div class="row p-2 m-0 dropzone">
      <div class="col">
        <div class="row">
          <div class="col-12">
            <div>
              <div class="DropAreaSingle AdicionarImagem--border">
                <span v-if="files.length > 0">
                  <b>Arquivos selecionados: </b>{{ showNameFiles && files.length }}<br>
                  <small>Para trocar, arraste o arquivo PDF  aqui ou <label for="preparar-processo-imagem"><u>procure manualmente</u></label> para upload </small>
                </span>
                <span v-if="files.length <= 0">
                  Arraste o arquivo PDF aqui ou <label for="preparar-processo-imagem"><u>procure manualmente</u></label> para upload
                </span>
              </div>

              <input id="preparar-processo-imagem"
                     v-validate="{required: true, mimes: ['application/pdf']}"
                     type="file"
                     name="imagem"
                     accept="application/pdf"
                     multiple
                     class="form-control-sm form-control-file file"
                     @dragover="($event) => dragArea($event)"
                     @dragleave="($event) => dragAreaOut($event)"
                     @drop="drop()"
                     @change="setFiles">
              <label v-if="1 != 1"
                     for="preparar-processo-imagem"
                     class="label">Adicionar um documento</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="files">
      <div class="row mt-3 ml-3 mr-3">
        <div v-for="(documento, index) in files"
             :key="index">
          <Documento :prop-documento="documento"
                     :prop-index="index"
                     @deleteDocumento="deleteDocumento" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// Componentes

  import Documento from '@/components/LivroCaixa/DocumentoLivroCaixa.vue'

  export default {
    name: "FormDocumentos",
    components: {
      Documento
    },
    props: {
      propForm: {
        type: Object,
        default: () => { return {} }
      }
    },
    data () {
      return {
        files: [],
        showNameFiles: true
      }
    },
    methods: {
      dragArea ($event) {
        const element = document.querySelector('.DropAreaSingle')
        element.classList.add('DropAreaDrag')
        $event.preventDefault()
      },

      dragAreaOut ($event) {
        const element = document.querySelector('.DropAreaSingle')
        element.classList.remove('DropAreaDrag')
        $event.preventDefault()
      },

      drop () {
        const element = document.querySelector('.DropAreaSingle')
        element.classList.remove('DropAreaDrag')
      },

      inputFiles () {
        const element = document.querySelector('.file')        
        return element && element.files[0] && element.files.length || null
      },
      setFiles (event) {
        const { files } = event.target
        let filesArray = []
        for (let file of files) {
          filesArray.push(file)
        }
        this.files = filesArray
        this.$emit('files', this.files)
        this.showFile = true
      },
      async deleteDocumento (index) {

        this.files.splice(index, 1)

        if (!this.files.length > 0) {
          this.showFile = true
        }
        this.$emit('files', this.files)
      },
    }
  }
</script>

<style scoped lang="scss">

.DropAreaSingle {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    padding: 5px;
    background-color: #f4f4f4;
    border:2px solid  #086AAE;;
    border-style: dashed;
  }

  .DropAreaDrag {
    height: 100px;
    padding: 5px;
    background-color: #3498db;
    color: #fff;
    border-color: #086AAE;
  }

  .file {
    height: 100px;
    padding: 5px;
    width: 94%;
    padding-top: 9%;
    background-color: #f4f4f4;
    border-color: #086AAE;
    opacity: 0;
    z-index: 10;
    position: absolute;
    top: 0;
  }

  .dropzone {
    margin-left: -10px;
  }
</style>
